import {
  BUILTIN_ROLES,
  type BuiltinRoleId,
} from "../../../../../shared/rbac/roles";
import {
  collectRoleChips,
  type GroupedRoleChip,
  type ResolveScopeName,
} from "../../../../lib/roleChip";

type GrantRow = {
  id: string;
  scopeId: string;
  builtinRoleId: string | null;
  customRoleId: string | null;
};

import type { RoleInfo } from "../../lib/buildAccessRows";
export type { RoleInfo } from "../../lib/buildAccessRows";

export function roleChipsForGrants(
  grants: readonly GrantRow[],
  resolveName: ResolveScopeName,
  fullAccessRoleIds: ReadonlySet<string>,
  rolesMap: ReadonlyMap<string, RoleInfo>,
  excludeScopeIds?: ReadonlySet<string>
): GroupedRoleChip[] {
  const filtered = excludeScopeIds
    ? grants.filter((g) => !excludeScopeIds.has(g.scopeId))
    : grants;
  const fullAccess = filtered.some((gr) => {
    if (gr.builtinRoleId) {
      const role = BUILTIN_ROLES[gr.builtinRoleId as BuiltinRoleId];
      return role?.permissions.includes("allow_all");
    }
    return gr.customRoleId ? fullAccessRoleIds.has(gr.customRoleId) : false;
  });
  if (fullAccess) {
    return [
      {
        key: "full-access",
        icon: "crown",
        label: "Full access",
        count: 1,
        details: ["Full access"],
        scopeKind: "tenant",
      },
    ];
  }
  const enriched = filtered.map((g) => ({
    ...g,
    customRole: g.customRoleId ? (rolesMap.get(g.customRoleId) ?? null) : null,
  }));
  return collectRoleChips(enriched, resolveName);
}
